import { Button } from "../models/common.models";
import { DialogCta } from "../models/custom-dialog.models";
import { DialogText, GeneralButtonLabel } from "./texts";

export const getConfirmButtons = (
  yesOrNoButtons: boolean = false
): Button[] => {
  return [
    {
      label: yesOrNoButtons ? DialogText.NO : DialogText.CANCEL,
      cta: DialogCta.CANCEL,
      color: "error",
    },
    {
      label: yesOrNoButtons ? DialogText.YES : DialogText.CONFIRM,
      cta: DialogCta.CONFIRM,
      color: "primary",
    },
  ];
};

export const getSubmitButton = (): Button => {
  return {
    label: GeneralButtonLabel.SUBMIT,
    cta: DialogCta.CONFIRM,
    color: "primary",
  };
};
